// import fetch from "auth/FetchInterceptor";
import { insuranceClient } from "api";

const SPPAService = {};

SPPAService.getSPPALoans = function (data) {
  const params = new URLSearchParams();

  // Pagination
  params.append("pageSize", data.pageSize);
  // params.append("page", data.pageIndex);
  params.append("pageMode", data.pageMode);
  params.append("status", data.status);

  // Filter (opsional, hanya dikirim jika ada nilai)
  if (data.branchId) params.append("branchId", data.branchId);
  if (data.jenisAktivasi) params.append("jenisAktivasi", data.jenisAktivasi);
  //if (data.maskAssID) params.append("maskAssID", data.maskAssID);
  if (data.maskAssName) params.append("maskAssName", data.maskAssName);
  if (data.jenis) params.append("jenis", data.jenis);

  // Untuk range date (pastikan backend bisa menerima format ini)
  if (data.startDate && data.endDate) {
    params.append("startDate", data.startDate);
    params.append("endDate", data.endDate);
  }

  return insuranceClient({
    url: `/loans?${params.toString()}`,
    method: "get",
  });

};

SPPAService.getSPPALoanDetail = function (data) {
  return insuranceClient({
    url: `/loans/${data.loanId}`,
    method: "get",

  });
};

SPPAService.putSPPAStatus = function (payload) {
  return insuranceClient({
    url: `/InsuranceAssets/update-sppa`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

SPPAService.cetakSPPAMulti = async function (loanIds) {
  try {
    const response = await insuranceClient({
      url: `/Print/CetakSPPAMulti`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: loanIds,
      responseType: "blob", // ⬅️ WAJIB supaya response-nya dianggap file
    });

    // blob ada di response.data
    const blob = response.data;
    return blob;
  } catch (error) {
    console.error("Error cetakSPPAMulti:", error);
    throw error;
  }
};

//POLIS
SPPAService.saveTerimaPolis = async function (payload) {
  try {
    return insuranceClient({
      url: `/polis/SaveTerimaPolis`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
  } catch (error) {
    console.error("Error cetakSPPAMulti:", error);
    throw error;
  }
};


export default SPPAService;